export function alertBarEvents() {
	const alertBar = document.getElementById("ilawyer-alert-bar");
	// if (!alertBar) {
	// 	deleteCookie("ilawyer-alert-bar");
	// 	return;
	// }
	if (alertBar) {
		// if (getCookie("ilawyer-alert-bar") === "closed") {
		// 	alertBar.style.display = "none";
		// 	return;
		// }
		(async () => {
			try {
				const { initAlertBar } = await import("./alert-bar.js");
				initAlertBar(alertBar);
			} catch (err) {
				console.error("Failed to load module:", err);
			}
		})();
	}
}

// // make cookies their own helper file later
// function getCookie(name) {
// 	const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
// 	return match ? decodeURIComponent(match[2]) : null;
// }
// // make cookies their own helper file later
// function deleteCookie(name) {
// 	document.cookie = `${name}=; max-age=0; path=/`;
// }
